import React from "react";
import { Route, Link, Switch, BrowserRouter as Router } from "react-router-dom";
import Temp from "./healthcheck/tempeture";
import Pul from "./healthcheck/pulse";
import Garment from "./healthcheck/garments";
import Alco from "./healthcheck/alcohol";
import DataSender, { BACKEND_URL } from "../../lib/DataSender";

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.location.state,
      tempeture: 36.5,
      pulse: 60,
      alcohol: 0.02,
      garments: true,
      path_count: 0,
    };
    this.ds = new DataSender();
    this.path = [
      "/QRresult/Tempeture",
      "/QRresult/Alcohol",
      "/QRresult/Pulse",
      "/QRresult/Garments",
    ];
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  checkChange = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  changePage = () => {
    if (this.state.path_count >= this.path.length) {
      this.props.history.push({
        pathname: "/End",
        state: { ...this.state },
      });
    } else {
      this.setState({
        ...this.state,
        path_count: this.state.path_count + 1,
      });
    }
  };

  getTempeture = () => {
    this.ds
      .getTempeture()
      .then((response) => response.json())
      .then((res) => {
        let data = res.data;
        if (data.tempeture == null) return;
        this.setState({ ...this.state, ...data });
      });
  };

  UserData() {
    return (
      <>
        <h1 style={{ marginTop: "100px" }}>신원 정보</h1>
        <span className="warning">틀린 정보가 없는지 확인해주세요.</span>
        <div className="result-user-data-qr">
          <img
            src={this.state ? `${BACKEND_URL}/img/${this.state.qr_img}` : "#"}
            alt="QR이미지"
          ></img>
        </div>
        <div className="result-user-data">
          <p>이름 : {this.state.name}</p>
          <p>전화번호 : {this.state.phone_number}</p>
          <p>군번 : {this.state.dt_number}</p>
          <p>
            부대 : {this.state.army_unit ? this.state.army_unit.unitName : ""}
          </p>
          <p>계급 : {this.state.level}</p>
          <p>생년월일 : {this.state.birth}</p>
        </div>
      </>
    );
  }

  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route
              path="/QRresult"
              exact
              component={this.UserData.bind(this)}
            ></Route>
            <Route path="/QRresult/Tempeture">
              <Temp
                change={this.handleChange}
                handle={this.getTempeture}
                value={this.state.tempeture}
              />
            </Route>
            <Route path="/QRresult/Alcohol">
              <Alco change={this.handleChange} />
            </Route>
            <Route path="/QRresult/Pulse">
              <Pul change={this.handleChange} />
            </Route>
            <Route path="/QRresult/Garments">
              <Garment change={this.checkChange} />
            </Route>
          </Switch>

          <div className="qrresult-buttons">
            <Link
              to={{
                pathname: (() => {
                  return this.path[this.state.path_count];
                })(),
              }}
              onClick={this.changePage}
              className="qrresult-button"
            >
              <button className="button">
                <p>다음으로</p>
              </button>
            </Link>
          </div>
        </Router>
      </div>
    );
  }
}

export default Result;
